import type { IntegerRollupMetadata, IntegerRollupReaders } from './integer-layer-rollup';
import { rollupIntegerFamilies } from './integer-layer-rollup';
import { readIntegerCompilePath } from './integer-compute-slots';
import { encounterCreatureField } from '../../shared/array-types';

/** Rewalk only the requested generic families against the updated held sources.
 * The caller installs its status/equipment row change first. Senses, speeds,
 * reach and attacks remain with their cluster owners. No full compiler/result
 * normalization runs here: actor, computed and sibling branches stay held.
 */
export function applyIntegerLayerDelta(row: Record<string, unknown>, requested: readonly string[],
    metadata: IntegerRollupMetadata, readers: IntegerRollupReaders) {
    const layers = [...new Set(requested)].filter(layer => metadata.integerLayers.includes(layer)
        && layer !== 'teleport' && !layer.startsWith('speed_') && layer !== 'reach' && layer !== 'extra_attack'
        && !metadata.sensesNames.includes(layer));
    const changes: { layer: string; before: unknown; after: unknown }[] = [];
    for (const layer of layers) {
        // Use the ordinary reader: explicit zero and absent computed slots have
        // different fallback behavior, especially for mitigation cancellation.
        const before = readers.layerValue(row, layer);
        const path = ['computed','creature','modifier_sources',layer];
        const sources = readIntegerCompilePath(row,path);
        rollupIntegerFamilies(row,metadata,readers,[layer]);
        const after = readers.layerValue(row,layer);
        if (before !== after || sources !== readIntegerCompilePath(row,path)) changes.push({layer,before,after});
    }
    const counts = (globalThis as { ftIntegerLayerDeltaCounts?: Record<string, { familiesVisited: number; calls: number }> }).ftIntegerLayerDeltaCounts;
    const id = String(encounterCreatureField(row.encounter_creatures, 'encounter_creature_id') ?? '').toUpperCase();
    if (counts && id && layers.length) {
        const member = counts[id] ??= { familiesVisited: 0, calls: 0 };
        member.familiesVisited += layers.length; member.calls++;
    }
    return {row,changes,familiesVisited:layers.length};
}
